import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts/:accountId/profiles/:profileId/entries`,
  transformer(data) {
    return data;
  }
};
